// extracted by mini-css-extract-plugin
module.exports = {"timeline":"styles_timeline__OZU8D","container":"styles_container__oMe2b","column":"styles_column__6jnt7"};